export default __webpack_public_path__ + "nighttrip.mp3";